import React from 'react';
import { Helmet } from 'react-helmet-async';

const MentionsLegales: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#E8EEF8] text-gray-700">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-6 py-20">

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Mentions légales
          </h1>
        </div>

        {/* Intro */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <p className="leading-relaxed text-gray-700">
            Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004 pour la confiance dans
            l'économie numérique, vous trouverez ci-dessous les mentions légales relatives au site{' '}
            <strong>www.totheroad.fr</strong>.
          </p>
          <p className="mt-4 leading-relaxed text-gray-700">
            Pour toute question, vous pouvez nous contacter à l'adresse :{' '}
            <a href="mailto:contact@totheroad.fr" className="text-blue-500 font-semibold hover:underline">
              contact@totheroad.fr
            </a>
          </p>
        </div>

        {/* Legal Content */}
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-10">

          {/* Section 1 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              1. Informations légales - Éditeur du site
            </h2>
            <div className="space-y-2 text-sm leading-relaxed text-gray-700">
              <p><strong>Forme juridique :</strong> SAS (Société par Actions Simplifiée)</p>
              <p><strong>Nom de la Société :</strong> TO THE ROAD</p>
              <p><strong>Activité :</strong> Plateforme d'intermédiation pour la location de véhicules de loisirs</p>
              <p><strong>Siège social :</strong> 61 rue de Lyon, 75012 Paris - France</p>
              <p>
                <strong>Email :</strong>{' '}
                <a href="mailto:contact@totheroad.fr" className="text-blue-500 hover:underline">
                  contact@totheroad.fr
                </a>
              </p>
              <p><strong>Capital social :</strong> 1 000 €</p>
              <p><strong>SIREN :</strong> 989 290 754</p>
              <p><strong>SIRET :</strong> 989 290 754 00013</p>
              <p><strong>RCS :</strong> Paris 989 290 754</p>
              <p><strong>Code APE/NAF :</strong> 7711A (Location de courte durée de voitures et de véhicules automobiles légers)</p>
              <p><strong>Numéro TVA intracommunautaire :</strong> FR37989290754</p>
              <p className="text-xs text-gray-300">
                <span className="font-normal">Directeur de la publication :</span> Mathieu DESCHAMPS
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              2. Assurance Responsabilité Civile Professionnelle
            </h2>
            <div className="space-y-3 text-sm leading-relaxed text-gray-700">
              <p>
                TO THE ROAD dispose d'une Assurance Responsabilité Civile Professionnelle souscrite auprès de :
              </p>
              <div className="ml-4 space-y-2 mt-4">
                <p><strong>Assureur :</strong> HISCOX SA</p>
                <p><strong>Forme juridique :</strong> Entreprise d'assurance</p>
                <p><strong>Siège social :</strong> 35 avenue Monterey, L-2163 Luxembourg</p>
                <p><strong>Enregistrement :</strong> Registre du commerce et des sociétés du Grand-Duché du Luxembourg sous le n° B217018</p>
                <p><strong>Agrément :</strong> Commissariat aux assurances (CAA)</p>
                <p><strong>Succursale en France :</strong> 49 avenue de l'Opéra, 75002 Paris</p>
                <p><strong>RCS France :</strong> Paris 833 546 989</p>
                <p><strong>Numéro de police :</strong> HRCP300066 (Responsabilité Civile Professionnelle)</p>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              3. Hébergeur du site
            </h2>
            <div className="space-y-2 text-sm leading-relaxed text-gray-700">
              <p><strong>Hébergeur :</strong> HOSTINGER INTERNATIONAL LTD</p>
              <p><strong>Adresse :</strong> 61 Lordou Vironos Street, 6023 Larnaca, Chypre</p>
              <p>
                <strong>Site web :</strong>{' '}
                <a href="https://www.hostinger.fr" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                  www.hostinger.fr
                </a>
              </p>
              <p>
                <strong>Contact :</strong>{' '}
                <a href="https://www.hostinger.fr/contact" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                  https://www.hostinger.fr/contact
                </a>
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              4. Protection des données personnelles
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                TO THE ROAD accorde une grande importance à la protection de vos données personnelles.
              </p>
              <p>
                <strong>Responsable du traitement :</strong> TO THE ROAD, 61 rue de Lyon, 75012 Paris, France
              </p>
              <p>
                Pour en savoir plus sur la collecte, l'utilisation, la conservation et vos droits concernant
                vos données personnelles, veuillez consulter notre{' '}
                <a href="/politique-confidentialite" className="text-blue-500 hover:underline">
                  Politique de Confidentialité
                </a>
                .
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              5. Propriété intellectuelle
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                L'ensemble des éléments de ce site (structure, textes, images, logos, vidéos, sons, bases
                de données, logiciels, éléments graphiques, etc.) est la propriété exclusive de TO THE ROAD
                ou fait l'objet d'une autorisation d'utilisation.
              </p>
              <p>
                Ces éléments sont protégés par les lois relatives au droit d'auteur et à la propriété
                intellectuelle. La marque « TO THE ROAD » ainsi que les logos figurant sur le site sont
                des marques déposées.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication, adaptation, transmission,
                dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce
                soit, et sur quelque support que ce soit est interdite sans l'autorisation écrite
                préalable de TO THE ROAD.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              6. Cookies et traceurs
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                Ce site utilise des cookies et autres traceurs pour améliorer l'expérience utilisateur
                et réaliser des statistiques de visites.
              </p>
              <p>Les cookies utilisés sur ce site sont :</p>
              <ul className="ml-6 space-y-2 list-disc">
                <li><strong>Cookies strictement nécessaires :</strong> Essentiels au fonctionnement du site</li>
                <li><strong>Cookies de performance :</strong> Pour analyser l'utilisation du site (Google Analytics)</li>
              </ul>
              <p>
                Pour en savoir plus sur les cookies et leur gestion, consultez notre{' '}
                <a href="/cookies" className="text-blue-500 hover:underline">
                  Politique Cookies
                </a>
                .
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              7. Limitation de responsabilité
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                TO THE ROAD s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées
                sur ce site, dont elle se réserve le droit de corriger le contenu à tout moment et sans
                préavis.
              </p>
              <p>
                TO THE ROAD ne pourra être tenue responsable des dommages directs ou indirects résultant
                de l'accès au site ou de l'utilisation du site, y compris l'inaccessibilité, les pertes
                de données ou virus qui pourraient affecter l'équipement informatique de l'utilisateur.
              </p>
              <p>
                <strong>Concernant les véhicules et locations :</strong> TO THE ROAD est une plateforme
                d'information et de redirection. TO THE ROAD n'est pas responsable des réservations,
                paiements, assurances ou tout litige résultant d'une location effectuée via les
                plateformes tierces.
              </p>
            </div>
          </section>

          {/* Section 8 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              8. Liens hypertextes
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                Le site peut contenir des liens hypertextes vers d'autres sites présents sur le réseau
                Internet. TO THE ROAD n'exerce aucun contrôle sur ces sites et décline toute responsabilité
                quant à leur contenu.
              </p>
              <p>
                La création de liens hypertextes vers le site www.totheroad.fr nécessite l'autorisation
                préalable et écrite de TO THE ROAD.
              </p>
            </div>
          </section>

          {/* Section 9 */}
          <section className="border-b border-[#E8EEF8] pb-10">
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              9. Droit applicable et juridiction compétente
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                Les présentes mentions légales sont régies par le droit français.
              </p>
              <p>
                En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux
                français compétents selon les règles de droit commun.
              </p>
              <p>
                Conformément à l'article 14 du Règlement (UE) n°524/2013, la Commission Européenne a mis
                en place une plateforme de Règlement en Ligne des Litiges, facilitant le règlement
                indépendant par voie extrajudiciaire des litiges en ligne entre consommateurs et
                professionnels de l'Union européenne. Cette plateforme est accessible au lien suivant :{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
            </div>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-xl font-bold text-blue-500 mb-5">
              10. Contact
            </h2>
            <div className="space-y-4 text-sm leading-relaxed text-gray-700">
              <p>
                Pour toute question concernant les présentes mentions légales ou pour toute demande
                d'information, vous pouvez nous contacter :
              </p>
              <div className="bg-gray-50 border-l-4 border-blue-400 p-4 rounded-r-lg space-y-1">
                <p>
                  <strong>Email :</strong>{' '}
                  <a href="mailto:contact@totheroad.fr" className="text-blue-500 hover:underline">
                    contact@totheroad.fr
                  </a>
                </p>
                <p><strong>Adresse :</strong> TO THE ROAD — 61 rue de Lyon, 75012 Paris, France</p>
              </div>
            </div>
          </section>

          {/* Footer */}
          <div className="pt-6 border-t-2 border-[#E8EEF8] text-center">
            <p className="text-gray-400 text-sm italic">
              Dernière mise à jour : 21 mars 2026
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
